export var I_DO_NOT_KNOW_ID = 'i-do-not-know';
export var MONEY_NANOS_MAX = 1000000000;